import { LLM } from '@/types'
import i18next from 'i18next'

import { CATEGORIES } from '../categories'

const MISTRAL_PLATORM_LINK = 'https://docs.mistral.ai/'

// Mistral Models (UPDATED 09/30/26) -----------------------------
// Prefer -latest GA aliases (Large 3 / Medium 3.5 / Small 4).

const MISTRAL_LARGE: LLM = {
  modelId: 'mistral-large-latest',
  modelName: 'Mistral Large',
  provider: 'mistral',
  hostedId: 'mistral-large-latest',
  platformLink: MISTRAL_PLATORM_LINK,
  imageInput: true,
  tier: 'pro',
  tools: true,
  new: true,
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  description: () => i18next.t('models.providers.mistral.mistral_large.description'),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 2,
    outputCost: 6
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.HEALTH,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.TRANSLATION,
    CATEGORIES.MULTIMODAL
  ]
}

const MISTRAL_MEDIUM: LLM = {
  modelId: 'mistral-medium-latest',
  modelName: 'Mistral Medium',
  provider: 'mistral',
  hostedId: 'mistral-medium-latest',
  platformLink: MISTRAL_PLATORM_LINK,
  imageInput: true,
  tier: 'pro',
  tools: true,
  new: true,
  description: () =>
    i18next.t(
      'models.providers.mistral.mistral_medium_latest.description',
      'Mistral Medium (latest) — long-horizon agentic coding and tool calling.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 0.4,
    outputCost: 2
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING
  ]
}

const MISTRAL_SMALL: LLM = {
  modelId: 'mistral-small-latest',
  modelName: 'Mistral Small',
  provider: 'mistral',
  hostedId: 'mistral-small-latest',
  platformLink: MISTRAL_PLATORM_LINK,
  imageInput: true,
  tier: 'pro',
  tools: true,
  new: true,
  description: () =>
    i18next.t(
      'models.providers.mistral.mistral_small_latest.description',
      'Mistral Small (latest) — fast multimodal model for everyday tasks.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 0.1,
    outputCost: 0.3
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.TRANSLATION,
    CATEGORIES.MULTIMODAL
  ]
}

export const MISTRAL_LLM_LIST: LLM[] = [MISTRAL_LARGE, MISTRAL_MEDIUM, MISTRAL_SMALL]
